module.exports = __webpack_public_path__ + "img/green-walking.d6c8fa32.svg";